import axios from "axios";

export default {
    async registro(params){
        
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/register",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({
                 nombre_usuario: params.email, 
                 id_tipo_usuario:1,
                 modulo:params.modulo,
                 tenant: params.tenant,
                 perfil:params.perfil,
                 tipo_id:params.tipoid,
                 numero_id:params.numeroid,
                 primer_nombre:params.primer_nombre, 
                 segundo_nombre:params.segundo_nombre,
                 primer_apellido:params.primer_apellido,
                 segundo_apellido:params.segundo_apellido,
                 celular:params.celular,
                 id_cliente:params.id_cliente,
                 }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }
     },

    // ─── Auto-registro de institución (sin token) ────────────────────────────────
    async registroInstitucion(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/registerpass_institucion",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({
                nombre_usuario:   params.nombre_usuario,
                tipo_id:          params.tipo_id,
                numero_id:        params.numero_id,
                primer_nombre:    params.primer_nombre,
                segundo_nombre:   params.segundo_nombre,
                primer_apellido:  params.primer_apellido,
                segundo_apellido: params.segundo_apellido,
                celular:          params.celular,
                password:         params.password,
                id_cliente:       params.id_cliente,
            }),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    // ─── Crear nueva institución pública (sin token) ─────────────────────────────
    async crearInstitucion(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/crear_institucion_publica",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({
                nombre_cliente:          params.nombre_cliente,
                numero_de_identificacion: params.numero_de_identificacion,
                tipo_de_identificacion:  params.tipo_de_identificacion,
                celular:                 params.celular || '',
                correo_electronico:      params.correo_electronico || '',
                tenant:                  params.tenant || 1,
            }),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    // ─── Búsqueda pública de instituciones/clientes (sin token) ─────────────────
    async buscarInstituciones(search, tenant) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/buscar_instituciones",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({
                search: search || '',
                tenant: tenant || 1,
            }),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
};
